import React, { useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Navigate } from 'react-router-dom';
import { LogoutSuccessSVG } from '../../../img/GlobalSVG';
import GenericButton from '../../../../Components/GenericButton/GenericButton';

const PasswordSuccess = ({ currentStep }) => {
  const [backtoLogin, setBackToLogin] = useState(false);
  const gobacktoLoginPage = () => {
    setBackToLogin(true);
  };

  if (backtoLogin) {
    return <Navigate to="/admin" push={true}></Navigate>;
  }

  return (
    <Container className="password-success-container text-center">
      <Row>
        <Col>
          <LogoutSuccessSVG.LogoutSuccessSVG />
        </Col>
      </Row>
      <Row>
        <Col>
          <div className="content-box">
            <h1 className="password-success-title">
              Your password has been <br /> successfully changed
            </h1>
            <p>Log in using new password</p>
            <GenericButton
              variant="primary"
              tabIndex="0"
              onClick={gobacktoLoginPage}
              className=" login-button d-flex mx-auto text-center "
              type="submit"
            >
              LOGIN AGAIN
            </GenericButton>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default PasswordSuccess;
